import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "./components/AuthContext.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  captureReferralAttributionFromUrl,
  initPosthog,
} from "./lib/posthog.ts";
import { initSentry } from "./lib/sentry.ts";
import { initMetaPixel } from "./lib/metaPixel.ts";
import { LocaleProvider } from "./i18n/LocaleProvider.tsx";

initSentry();

const queryClient = new QueryClient();
captureReferralAttributionFromUrl();
initPosthog();
initMetaPixel();

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LocaleProvider>
          <App />
        </LocaleProvider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>,
);
